<template>
    <div class="profile" v-bind:class="profileClass">
        <div class="profile__header" v-on:click="toggleVisibility">
            <div class="profile__header-icon"></div>
            <div class="profile__title">Mijn profiel</div>
            <div class="profile__toggle-btn" v-bind:class="toggleBtnClass"></div>
        </div>
        <div class="profile__result">
            <p class="profile__result-row">
                <span class="profile__description" v-if="userProfile.baan1!==null">
                    {{formatJobName(userProfile.baan1)}}
                    <span v-if="userProfile.uren1!==null"> Als hybride docent wil ik {{formatDagen(userProfile.uren1)}} per week in
                    mijn huidige baan blijven werken.</span>
                </span>
            </p>

            <p class="profile__result-row">
                <span class="profile__description" v-if="userProfile.baan2!==null">
                    Mijn huidige baan wil ik combineren {{formatJobName(userProfile.baan2)}}.
                    <span v-if="userProfile.uren2">Dit werk wil ik {{formatDagen(userProfile.uren2)}} per week doen.</span>
                </span>
            </p>

            <p class="profile__result-row" v-if="userProfile.onderwijsniveau">
                Ik wil lesgeven in het {{userProfile.onderwijsniveau.toLowerCase()}}.
                <span v-if="userProfile.vak2!==null">Ik wil graag het vak {{userProfile.vak2.vak}} doceren.</span>
            </p>

            <p class="profile__result-row" v-if="userProfile.baan1 && userProfile.baan1.isTeacher===false">
                <span v-if="userProfile.bevoegdheid===false">Ik heb geen lesbevoegdheid.</span>
                <span v-if="userProfile.bevoegdheid===true">Ik heb een lesbevoegdheid.</span>
            </p>

            <p v-if="userProfile.hasSubmitted">Ik heb dit plan verstuurd!</p>
        </div>
    </div>
</template>
<style lang="stylus">
    @require "../../styles/variables.styl";

    .profile
        display none
        right 15px
        position fixed
        background-color #ffffff
        color $color-main-1
        box-shadow 0px 0px 22px 3px rgba(233, 102, 97, 0.4)
        border 1px solid #fff

    .profile__header
        background-color $color-main-1
        height 70px
        color #fff
        font-family $font-button
        cursor pointer

    .profile__header-icon
        width 50px
        height @width
        background-color #fff
        border-radius 50%
        float left
        background-image url("../../assets/images/hybride-vrouw-50.png")
        background-size contain
        background-position center
        background-repeat no-repeat
        border 2px solid @background-color
        margin 10px

    .profile__title
        font-size 1.2em
        line-height 70px

    .profile__toggle-btn
        position absolute
        top 10px
        right 10px
        font-size 1.2em
        font-family Helvetica, Arial, sans-serif
        padding 3px

        &:hover
            background-color lighten($color-main-1, 10)
        &:before
            content "+"
            display block
            transition transform .6s
        &.profile__toggle-btn--show-close:before
            transform rotate(45deg)


    .profile__result
        padding $padding
        max-height calc(100vh - 70px)
        overflow auto
        font-size .9em

    @media only screen and (min-width: 45em) /* 720px */
        .profile
            display block
            width 300px
            top calc(100vh - 70px)
            bottom -10%
            &.profile--visible
                top auto
                bottom 0

</style>
<script>
    export default{
        props: {
            userProfile: {
                type: Object,
                default: () => { return {}; }
            }
        },
        data() {
            return {
                showComponent: true
            }
        },
        computed: {
            profileClass() {
                return {
                    'profile--visible': this.showComponent
                }
            },
            profileClass() {
                return {
                    'profile--visible': this.showComponent
                }
            },
            toggleBtnClass() {
                return {
                    'profile__toggle-btn--show-close': this.showComponent
                }
            }
        },
        methods: {
            clickHandler() {
                this.$emit('click');
            },
            formatDagen(nmbDays) {
                return nmbDays === 1 ? '1 dag' : `${nmbDays} dagen`;
            },
            formatJobName(job) {
                return job ? job.profileText : '';
            },
            toggleVisibility() {
                this.showComponent = !this.showComponent;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// profile.vue?b9188e72